import Immutable from 'immutable';

import {mergeNormalizedFetchData} from 'app/utils/redux';

import {RECEIVE_OBJECT_REVIEW, REQUEST_REVIEW} from 'app/review/actions';

export const initialState = {
  isLoading: false,
  objects: {},
};

export function reviews(state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    case REQUEST_REVIEW:
      return state.set('isLoading', true);

    case RECEIVE_OBJECT_REVIEW: {
      const {data, objectId, contentType} = action;
      const path = ['objects', contentType, objectId.toString()];
      return state.setIn(
        path,
        mergeNormalizedFetchData(
          data,
          state.getIn(path),
          // reset allIds if we are fetching the first page
          data.previous != null
        )
      );
    }

    default:
      return state;
  }
}
